const route = {
	path: ':customerName?/:customerId?/companies',
	name: 'companies',
	meta: {
		title: 'Empresas',
	},
	component: () => import('@/pages/companies/page-company'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/companies.js